/* eslint-disable */
export class StatusData {
    status: string;
    updated_at: number;
    version: number;
}
